import React from 'react';
import PropTypes from 'prop-types';
import { CustomInput, Card } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Field } from 'react-final-form';

import { FormError } from 'components/Form/FormField';
import AddonsBanner from 'components/Banners/customSurveyAddOn';
import { required } from 'utils/formValidators';
import RecurringCustomSurvey from '../recurringCustomSurvey';
import RewardConfiguration from './rewardConfiguration';

const SurveyAdditionalOptions = ({
  values,
  form,
  addonActive,
  socialMediasEnabled,
  socialReviewsEnabled,
  editForm,
}) => (
  <React.Fragment>
    <label className="mt-4"> Additional Options</label>
    <RecurringCustomSurvey />
    <Card className="styled-box-shadow p-3">
      <Field name="rewardCheckbox" type="checkbox">
        {({ input }) => {
          return (
            <div>
              <div className="custom-survey-field px-3 mt-2" fluid>
                <CustomInput id={input.name} {...input} />
                <label htmlFor={input.name} className="cursor-pointer">
                  Include a reward for completing this survey
                </label>
              </div>
              {values.rewardCheckbox && (
                <RewardConfiguration form={form} values={values} />
              )}
            </div>
          );
        }}
      </Field>
    </Card>
    {editForm && (
      <Card className="styled-box-shadow mt-3 p-3">
        <Field name="addonCheckbox" type="checkbox" disabled={!addonActive}>
          {({ input, labelClassName, disabled }) => {
            return (
              <div>
                <div className="custom-survey-field mt-2 pl-3 " fluid>
                  <CustomInput id={input.name} {...input} disabled={disabled} />
                  <label htmlFor={input.name} className={labelClassName}>
                    Grow my business with this survey
                  </label>
                </div>
                {values.addonCheckbox && (
                  <div className="pl-3">
                    <Card className="p-3 py-2 bg-light border-0 mb-2">
                      <Field
                        name="default_addon"
                        component="input"
                        type="radio"
                        value="social_media"
                        inputClassName="d-inline"
                        labelClassName={!socialMediasEnabled && 'text-muted'}
                        validate={required}
                        disabled={!socialMediasEnabled}
                      >
                        {({
                          input,
                          inputClassName,
                          disabled,
                          labelClassName,
                        }) => (
                          <div className="d-inline mt-2 pl-3 " fluid>
                            <div>
                              <label
                                htmlFor={input.value}
                                className={labelClassName}
                              >
                                <CustomInput
                                  className={inputClassName}
                                  id={input.value}
                                  {...input}
                                  disabled={disabled}
                                />
                                Grow social media following
                              </label>
                            </div>
                            {disabled && (
                              <div className="addon-disabled">
                                <FontAwesomeIcon icon="exclamation-triangle" />
                                You have not configured the Social Media Growth
                                Add-on
                              </div>
                            )}
                          </div>
                        )}
                      </Field>
                    </Card>
                    <Card className="p-3 py-2 bg-light border-0 mt-2">
                      <Field
                        name="default_addon"
                        component="input"
                        type="radio"
                        value="social_review"
                        inputClassName="d-inline"
                        validate={required}
                        labelClassName={!socialReviewsEnabled && 'text-muted'}
                        disabled={!socialReviewsEnabled}
                      >
                        {({
                          input,
                          inputClassName,
                          disabled,
                          labelClassName,
                        }) => (
                          <div className="d-inline mt-2 pl-3 " fluid>
                            <div>
                              <label
                                htmlFor={input.value}
                                className={labelClassName}
                              >
                                <CustomInput
                                  className={inputClassName}
                                  id={input.value}
                                  {...input}
                                  disabled={disabled}
                                />
                                Improve my ratings on Review Sites
                              </label>
                            </div>
                            {disabled && (
                              <div className="addon-disabled">
                                <FontAwesomeIcon icon="exclamation-triangle" />
                                You have not configured the Review Site Growth
                                Add-on
                              </div>
                            )}
                          </div>
                        )}
                      </Field>
                    </Card>
                    <FormError name="default_addon" />
                  </div>
                )}
              </div>
            );
          }}
        </Field>
        <AddonsBanner addonActive={addonActive} />
      </Card>
    )}
    <Card className="styled-box-shadow mt-3 p-3">
      <Field
        name="international"
        type="checkbox"
        render={({ input }) => {
          return (
            <div className="custom-survey-field mt-2 pl-3 " fluid>
              <CustomInput id={input.name} {...input} />
              <label htmlFor={input.name} className="cursor-pointer">
                Allow this survey to be taken outside of US and Canada
              </label>
            </div>
          );
        }}
      />
    </Card>
  </React.Fragment>
);

SurveyAdditionalOptions.defaultProps = {
  addonActive: false,
  socialMediasEnabled: false,
  socialReviewsEnabled: false,
  editForm: false,
};

SurveyAdditionalOptions.propTypes = {
  values: PropTypes.shape({
    rewardCheckbox: PropTypes.bool,
    addonCheckbox: PropTypes.bool,
  }).isRequired,
  form: PropTypes.node.isRequired,
  addonActive: PropTypes.bool,
  socialMediasEnabled: PropTypes.bool,
  socialReviewsEnabled: PropTypes.bool,
  editForm: PropTypes.oneOfType([PropTypes.bool, undefined]),
};

export default SurveyAdditionalOptions;



// WEBPACK FOOTER //
// ./src/components/customSurvey/FormFields/surveyAdditionalOptions.js